export const HEAP_SNAX_EVENT_PREFIX = 'ax.';
